export default __webpack_public_path__ + "assets/snowflake.bed7105c.svg";